import React from "react";

import { Container } from "./Exercise.sc";
import ExerciseHeader from "./ExerciseHeader";

interface ExerciseTemplateProps {
    onNextButtonClick: () => void;
    onBeforeEndButtonClick: () => void;
    loading?: boolean;
    children?: React.ReactNode;
    disableNextButton?: boolean;
}

const ExerciseTemplate: React.FunctionComponent<ExerciseTemplateProps> = ({
    onBeforeEndButtonClick,
    onNextButtonClick,
    loading,
    children,
    disableNextButton,
}) => {
    return (
        <>
            <ExerciseHeader
                onNextButtonClick={onNextButtonClick}
                onEndButtonClick={onBeforeEndButtonClick}
                loading={loading}
                disableNextButton={disableNextButton}
            />
            <Container>{children}</Container>
        </>
    );
};

export default ExerciseTemplate;
